module.exports = __webpack_public_path__ + "media/images/asian-931432f5de0d7bc9c424829a9a010bf1.png";